var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { bindActionCreators } from 'redux';
import { eventChannel } from 'redux-saga';
import { all, call, put, select, take, takeEvery } from 'redux-saga/effects';
import { getUpdatedProcess_AC } from '../actions/process';
import * as wsActions from '../actions/websocket';
import { authenticateSelector } from '../selectors/authenticate';
var wsActionTypes = wsActions.types;
var ws = undefined;
var defaultDomainAndPort = window.location.href
    .replace('http://', '')
    .split('/')[0];
var socketURL = function (domain, port, token, isSecured, contextPath) {
    return (isSecured ? 'wss' : 'ws') + "://" + (domain != undefined && port != undefined
        ? domain + (port ? ':' + port : '')
        : defaultDomainAndPort) + contextPath + "/api/ws?token=" + token;
};
var eventHandlers = {
    onopen: wsActions.socketOpen_AC,
    onclose: wsActions.socketClose_AC,
    onerror: wsActions.socketError_AC,
    onmessage: wsActions.socketMessage_AC,
};
var connectSocket = function (_a) {
    var domain = _a.domain, port = _a.port, isSecured = _a.isSecured, token = _a.token, saveWs = _a.saveWs, onWebsocketClose = _a.onWebsocketClose, _b = _a.contextPath, contextPath = _b === void 0 ? '' : _b, subscribeData = _a.subscribeData;
    return eventChannel(function (emitter) {
        ws = new window.WebSocket(socketURL(domain, port, token, isSecured, contextPath), 'exacta-notifications');
        ws.token = token;
        var boundEventHandlers = bindActionCreators(eventHandlers, emitter);
        ws.onopen = function (e) {
            console.log('websocket onopen', { e: e, ws: ws });
            boundEventHandlers.onopen();
        };
        ws.onclose = function () {
            var auth;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('websocket onclose', { ws: ws });
                        return [4, select(authenticateSelector)];
                    case 1:
                        auth = _a.sent();
                        if (auth.token === token) {
                            boundEventHandlers.onclose();
                            ws = undefined;
                        }
                        return [2];
                }
            });
        };
        ws.onerror = boundEventHandlers.onerror;
        ws.onmessage = boundEventHandlers.onmessage;
        ws.onclosing = function (e) { return console.log('ws onclosing', e); };
        ws.onWebsocketClose = onWebsocketClose;
        saveWs && saveWs(ws);
        return ws.onclose;
    });
};
var storeMessageData = function (_a) {
    var data, messageType, notifications;
    var payload = _a.payload, type = _a.type;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                data = payload.data;
                messageType = data.type;
                console.log('websocket onmessage', { data: data, ws: ws });
                if (!(messageType === 'notifications')) return [3, 2];
                notifications = data.notifications;
                return [4, all(notifications.map(function (notification) {
                        var process = notification.process;
                        return put(getUpdatedProcess_AC(process, true));
                    }))];
            case 1:
                _b.sent();
                _b.label = 2;
            case 2:
                if (messageType === 'acknowledge') {
                }
                return [2];
        }
    });
};
var socketSaga = function (_a) {
    var socketChannel, eventAction;
    var payload = _a.payload, type = _a.type;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                console.log('connectSocket', { payload: payload });
                return [4, call(connectSocket, payload)];
            case 1:
                socketChannel = _b.sent();
                _b.label = 2;
            case 2:
                if (!true) return [3, 5];
                return [4, take(socketChannel)];
            case 3:
                eventAction = _b.sent();
                return [4, put(eventAction)];
            case 4:
                _b.sent();
                return [3, 2];
            case 5: return [2];
        }
    });
};
var closeSocket = function (data) {
    var auth;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                console.log('closeSocket', { ws: ws, data: data });
                return [4, select(authenticateSelector)];
            case 1:
                auth = _a.sent();
                if (!(ws && auth.token === ws.token)) return [3, 3];
                console.log('closeSocket closing socket', { ws: ws, data: data });
                return [4, put(wsActions.socketClose_AC())];
            case 2:
                _a.sent();
                ws.close();
                ws = undefined;
                _a.label = 3;
            case 3: return [2];
        }
    });
};
var subscribeToProcessSaga = function (_a) {
    var processes, auth;
    var payload = _a.payload, type = _a.type;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                processes = payload.processes;
                return [4, select(authenticateSelector)];
            case 1:
                auth = _b.sent();
                if (ws && auth.token === ws.token) {
                    ws.send(JSON.stringify({
                        type: 'subscribe',
                        processes: processes,
                    }));
                }
                return [2];
        }
    });
};
var unsubscribeToProcessSaga = function (_a) {
    var processes, auth;
    var payload = _a.payload, type = _a.type;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                processes = payload.processes;
                return [4, select(authenticateSelector)];
            case 1:
                auth = _b.sent();
                if (ws && auth.token === ws.token) {
                    ws.send(JSON.stringify({
                        type: 'unsubscribe',
                        processes: processes,
                    }));
                }
                return [2];
        }
    });
};
var actionWatcher = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, takeEvery(wsActionTypes.CONNECT_SOCKET, socketSaga)];
            case 1:
                _a.sent();
                return [4, takeEvery(wsActionTypes.SOCKET_MESSAGE, storeMessageData)];
            case 2:
                _a.sent();
                return [4, takeEvery(wsActionTypes.CLOSE_SOCKET, closeSocket)];
            case 3:
                _a.sent();
                return [4, takeEvery(wsActionTypes.SUBSCRIBE_TO_PROCESS, subscribeToProcessSaga)];
            case 4:
                _a.sent();
                return [4, takeEvery(wsActionTypes.UNSUBSCRIBE_TO_PROCESS, unsubscribeToProcessSaga)];
            case 5:
                _a.sent();
                return [2];
        }
    });
};
export default actionWatcher;
//# sourceMappingURL=websocket.js.map